import React from "react";
import "../../css/Checkout.css";

const CheckoutInformation = ({
  name,
  setName,
  tableNumber,
  setTableNumber,
  cardHolder,
  setCardHolder,
  cardNumber,
  setCardNumber,
  expiry,
  setExpiry,
  cvv,
  setCvv,
}) => {
  const handleCardNumberChange = (e) => {
    const raw = e.target.value.replace(/\D/g, "");
    const formatted = raw.match(/.{1,4}/g)?.join(" ") || "";
    setCardNumber(formatted);
  };

  const handleCvvChange = (e) => {
    const raw = e.target.value.replace(/\D/g, "");
    const formatted = raw.match(/.{1,3}/g)?.join(" ") || "";
    setCvv(formatted);
  };

  const handleExpiryChange = (e) => {
    const raw = e.target.value.replace(/\D/g, "");
    const formatted = raw.match(/.{1,2}/g)?.join("/") || "";
    setExpiry(formatted);
  };
  return (
    <div className="checkout-info">
      <label>
        <span>Customer Name</span>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
      </label>
      <label>
        <span>Table Number</span>
        <input
          type="number"
          value={tableNumber}
          onChange={(e) => setTableNumber(e.target.value)}
          required
        />
      </label>
      <label>
        <span>Card Holder Name</span>
        <input
          type="text"
          value={cardHolder}
          onChange={(e) => setCardHolder(e.target.value)}
          required
        />
      </label>

      <label>
        <span>Card Number</span>
        <input
          type="text"
          inputMode="numeric"
          value={cardNumber}
          onChange={handleCardNumberChange}
          placeholder="1234 5678 9012 3456"
          pattern="\d{4} \d{4} \d{4} \d{4}"
          required
        />
      </label>

      <div style={{ display: "flex", gap: "5em" }}>
        <label>
          <span>Expiration</span>
          <input
            type="text"
            value={expiry}
            onChange={handleExpiryChange}
            placeholder="MM/YY"
            pattern="\d{2}/\d{2}"
            maxLength={5}
            required
          />
        </label>

        <label>
          <span>CVV</span>
          <input
            type="text"
            value={cvv}
            onChange={handleCvvChange}
            pattern="\d{3}"
            maxLength={4}
            required
          />
        </label>
      </div>
    </div>
  );
};

export default CheckoutInformation;
